import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnableWorkflowNlp = (): boolean => useFeatureFlag(FeatureFlagDeclarations.enableWorkflowNlp);
